import React, { useState } from 'react'
import Modal from '../modal/modal'
import CloseSVG from '../../assets/svg/close.svg'
import AsyncSelect from 'react-select/async'
import { employees as employeeAPI } from '../../api/employees'
import { formValidation } from '../../utils/functions'
import { useForm } from 'react-hook-form'
import Button from '../button'
import FormInput from '../form-input'
import DOMPurify from 'dompurify'
import { useUpdateVoluntaryPension } from '../../redux/employees/hook/salaries'
import { store } from '../../redux'
import { setAlert } from '../../redux/components/components-slice'

const SingleUpdateVoluntaryPension = ({ isOpen, closeModal }) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  })
  const { mutateAsync: updateVoluntaryPension, isLoading } =
    useUpdateVoluntaryPension()
  const [selectedEmployeeData, setSelectedEmployeeData] = useState(null)
  const [employee, setEmployee] = useState()

  const loadOptions = (inputValue) =>
    new Promise((resolve) => {
      employeeAPI
        .getEmployees({
          limit: 10,
          statusFilter: -1,
          search: inputValue,
          page: 1,
        })
        .then((response) => {
          let data = []
          response.data.forEach((item) => {
            data.push({
              label: `${item.first_name} ${item.last_name}`,
              value: item.id,
              data: item,
            })
          })

          resolve(data)
        })
        .catch((err) => {
          resolve([])
        })
    })

  const handleEmployeeSelect = (option) => {
    setEmployee(option.value)
    setSelectedEmployeeData(option.data)

    if (option.data) {
      setValue(
        'employee_voluntary_pension',
        option.data?.compensation?.employee_voluntary_pension || ''
      )
      setValue(
        'employer_voluntary_pension',
        option.data?.compensation?.employer_voluntary_pension || ''
      )
    }
  }

  const submitForm = async (data) => {
    const employee_voluntary_pension = DOMPurify.sanitize(
      data?.employee_voluntary_pension
    )
    const employer_voluntary_pension = DOMPurify.sanitize(
      data?.employer_voluntary_pension
    )
    let payload = {
      id: employee,
      data: {
        employee_voluntary_pension,
        employer_voluntary_pension,
      },
    }
    await updateVoluntaryPension(payload).then(() => {
      store.dispatch(
        setAlert(true, 'success', 'Voluntary Pension Updated Successfully')
      )
      closeModal()
      setEmployee(null)
      setSelectedEmployeeData(null)
      setValue('employee_voluntary_pension', '')
      setValue('employer_voluntary_pension', '')
    })
  }
  return (
    <div>
      <Modal
        scrollable={true}
        className='!max-w-[600px] !rounded-none overflow-auto'
        isOpen={isOpen}
        centered={true}
      >
        <div className='flex flex-col overflow-auto w-full'>
          <div className='px-3 pt-4'>
            <div className='flex justify-between items-center'>
              <span className='header-4'>
                Update Employee Voluntary Pension
              </span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
          <hr className='divider' />
          <form
            onSubmit={handleSubmit(submitForm)}
            className='flex flex-col items-center w-full gap-3 px-3 mb-3'
          >
            <div className='w-full flex flex-col gap-2'>
              <label className='!text-[13px] leading-[23px] font-normal text-black'>
                Select Employee
              </label>
              <AsyncSelect
                isMulti={false}
                cacheOptions
                defaultOptions
                className='text-[13px] w-full'
                placeholder={'Type to select employee'}
                loadOptions={loadOptions}
                onChange={handleEmployeeSelect}
                classNamePrefix='mySelect'
              />
            </div>
            <div className='w-full'>
              <FormInput
                label={'Employee Pension'}
                placeholder={'Employee Pension'}
                name='employee_voluntary_pension'
                type='text'
                inputRef={register(formValidation('text', true))}
                error={errors.employee_voluntary_pension}
                errorMessage={
                  errors.employee_voluntary_pension &&
                  errors.employee_voluntary_pension.message
                }
              />
            </div>
            <div className='w-full'>
              <FormInput
                label={'Employeer Pension'}
                placeholder={'Employeer Pension'}
                name='employer_voluntary_pension'
                type='text'
                inputRef={register(formValidation('text', true))}
                error={errors.employer_voluntary_pension}
                errorMessage={
                  errors.employer_voluntary_pension &&
                  errors.employer_voluntary_pension.message
                }
              />
            </div>
            <div className='w-full'>
              <Button
                text='Update Voluntary Pension'
                type='submit'
                loading={isLoading}
                disabled={!employee}
              />
            </div>
          </form>
        </div>
      </Modal>
    </div>
  )
}

export default SingleUpdateVoluntaryPension
